"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.symbol = symbol;
function symbol() {
    // eslint-disable-next-line max-len,quotes
    return '<symbol viewbox="0 0 16 16" id=icon-confirmation-filled-16><path fill-rule=evenodd clip-rule=evenodd d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm11.207-.793a1 1 0 0 0-1.414-1.414L7 8.586l-.793-.793a1 1 0 0 0-1.414 1.414l1.5 1.5a1 1 0 0 0 1.414 0l3.5-3.5Z"></path></symbol>';
}
